import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemBfName, FormItemBfNo} from '../BF/FormChooseBf.jsx'
import Model from './ModelBfdataflow.mjs'

export const FormItemAlgTitle = props => (
    <FormItemBizProp
        Model={Model}
        prop="algTitle"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseBfdataflow(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemBfNo />
            <FormItemBfName />
            <FormItemAlgTitle />
        </FormChooseDesign>
    )
}
